<template>
  <div id="hero">
    <div class="hero">
      <div class="hero_content">
        <!-- <h1>ON THIS ISLAND, WE'RE FAMILY</h1> -->

        <div class="text">
          <h3>A New Era Starts Now</h3>

          <p>
            SEASON TICKET MEMBERS RECEIVE BEST-IN-CLASS TICKET PRICING, SAVINGS
            ON PARKING AND CONCESSIONS, AND MORE ACCESS TO THE TEAM
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
export default {
  name: "Hero",

  setup() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.hero {
  background-image: url("~images/hero/bg-hero.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 50px 0;
  z-index: 12;

  &::after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba($color: #000000, $alpha: 0.2);
    z-index: -1;
  }

  &_content {
    width: 95%;
    text-align: center;

    h1 {
      color: #fff;
      text-align: center;
      font-family: Prompt;
      font-size: 96px;
      font-style: normal;
      font-weight: 900;
      line-height: 88px; /* 91.667% */
      letter-spacing: -0.305px;
      margin-bottom: 34px;

      @media screen and (max-width: 789px) {
        font-size: 48px;
        line-height: 48px;
      }
    }

    .text {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 30px;
      h3 {
        color: #fff;
        text-align: center;
        font-family: Prompt;
        font-size: 56px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px; /* 114.286% */
        letter-spacing: -0.305px;
        margin-bottom: 0;
        text-transform: uppercase;

        @media screen and (max-width: 789px) {
          font-size: 36px;
          line-height: 40px;
        }
      }

      p {
        color: #fff;
        font-family: Prompt;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px; /* 150% */
        margin-bottom: 0;
        text-align: center;
        max-width: 900px;

        @media screen and (max-width: 789px) {
          font-size: 18px;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
